import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as CyberCareActions from './../actions/cyber-care.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { CpvService } from '../../../services/cpv.service';

@Injectable()
export class CyberCareEffects {
  @Effect()
  productPrice$: Observable<Action> = this.actions$.pipe(
    ofType(CyberCareActions.GET_CYBER_CARE_PRODUCT_PRICE),
    mergeMap((action: CyberCareActions.GetCyberCareProductPrice) =>
      this.cpvService.getProductPrice(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new CyberCareActions.GetCyberCareProductPriceSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new CyberCareActions.GetCyberCareProductPriceFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private cpvService: CpvService,
  ) {}
}
